import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {FacadeService} from "../shared/service-facade/facade.service";
import {environment} from "../../environments/environment";
import { BrandType } from '../signup/models/brand-type';
import {HomepageEnum} from "../shared/model/homepage.enum";

@Injectable({
  providedIn: 'root'
})
export class ProductGuard implements CanActivate {

  constructor(private facade: FacadeService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let product = route.queryParams.product;
    const isBaskURL = this.facade.isBaskURL();

    // if the product string doesn't exist or is empty, return false
    if (!product || product === "") {
      if (isBaskURL) window.location.href = HomepageEnum.BASK_PRODUCT_SELECTION;
      else window.location.href = HomepageEnum.TCB_PRODUCT_SELECTION;
    }

    const isActive = this.facade.isActiveProduct(product);
    if (isActive) {
      this.facade.getProduct(product).then((productInfo) => {
        if (productInfo.brandId == BrandType.PrivateWealth) {
          window.location.href = environment.productSelectionUrl;
        }
      }).catch(error => {
        if (isBaskURL) {
          window.location.href = HomepageEnum.BASK_PRODUCT_SELECTION;
        } else {
          window.location.href = HomepageEnum.TCB_PRODUCT_SELECTION;
        }
      });
    }
    return isActive;
  }
}
